import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { productService } from "@/services/api/cresivoxServer";


import {iProductDetails, REDUCER_NAME} from "./Types";
import { iProductResponse } from "../project/Types";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

//   export const getProductList = createAsyncThunk<
//   iGenericResponse<iProductDetails | null> | null,
// void,
//   {
// 	  rejectValue: iStateMessage;
//   }
// >(
//   curriedGetThunkName("productList"),
//   // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
//   async (arg, {rejectWithValue}) => {
// 	  try {
// 		  const response = await productService.listProducts();
		  
// 		  if (response) {
// 			  const {httpStatusCode, data, message} = response;

// 			  switch (httpStatusCode) {
// 				  case httpStatusCodes.SUCCESS_OK: {
// 					  if (data && data.data) {
//   const updatedData = data.data.map((item: any) => {
//     if (item.product?.is_imported === 1) {
//       const shipping = parseFloat(item.product.shippingPrice || '0');
//       const packaging = parseFloat(item.product.packagingCharges || '0');
//       const cost = parseFloat(item.product.cost_price || '0');
// 	const taxPercent = Number(item.product.taxesAndCharges || '0'); // Convert to number
// const taxCharges = (cost * taxPercent) / 100;
// // console.log("this is all products", shipping,packaging,cost);
//       // Update cost_price and reset others
//       item.product.cost_price = shipping + packaging + cost + taxCharges;
//       item.product.shippingPrice = "0";
//       item.product.packagingCharges = 0;
// 	item.product.taxesAndCharges="0";
// 	item.product.taxOptions='';
//     }
//     return item;
//   });

// //   console.log("this is all products", updatedData);

//   return {
//     httpStatusCode,
//     data: updatedData,
//     message,
//   };
// }
//  else {
// 						  return rejectWithValue({
// 							  httpStatusCode,
// 							  message,
// 						  });
// 					  }
// 				  }
// 				  default: {
// 					  return rejectWithValue({
// 						  httpStatusCode,
// 						  message,
// 					  });
// 				  }
// 			  }
// 		  } else {
// 			  return rejectWithValue({
// 				  message: "No response received",
// 			  });
// 		  }
// 	  } catch (error) {
// 		  console.log("🚀 ~ error:", error);
// 		  return rejectWithValue({
// 			  message: "Something went wrong",
// 		  });
// 	  }
//   },
// );

export const getProductList = createAsyncThunk<
  iGenericResponse<iProductDetails | null> | null,
  { page?: number; limit?: number; search?:string ; brand?:string; title?:string } | undefined,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("productList"),
  // @ts-expect-error
  async (args, { rejectWithValue }) => {
    try {
      const page = args?.page;
      const limit = args?.limit;
	  const search = args?.search;
	   const title = args?.title;
      const brand = args?.brand;
	 

      const response = await productService.listProducts(page, limit , search , title , brand);

      if (!response) {
		
        return rejectWithValue({ message: "No response received" });
      }

      const { httpStatusCode, data, message } = response;

      if (httpStatusCode !== httpStatusCodes.SUCCESS_OK) {
        return rejectWithValue({ httpStatusCode, message });
      }

      if (!data?.data) {
        return rejectWithValue({ httpStatusCode, message });
      }


      // ✅ Normalize — handle both paginated & simple array response
      const productArray = Array.isArray(data.data)
        ? data.data
        : data.data.products || [];

      // ✅ Extract pagination only if exists
      const pagination = Array.isArray(data.data)
        ? null
        : data.data.pagination ?? null;

      // ✅ Modify product pricing if imported
      const updatedData = productArray.map((item: any) => {
        if (item.product?.is_imported === 1) {
          const shipping = parseFloat(item.product.shippingPrice || "0");
          const packaging = parseFloat(item.product.packagingCharges || "0");
          const cost = parseFloat(item.product.cost_price || "0");
          const taxPercent = Number(item.product.taxesAndCharges || "0");
          const taxCharges = (cost * taxPercent) / 100;

          item.product.cost_price = shipping + packaging + cost + taxCharges;
          item.product.shippingPrice = "0";
          item.product.packagingCharges = 0;
          item.product.taxesAndCharges = "0";
          item.product.taxOptions = "";
        }
        return item;
      });

      return {
        httpStatusCode,
        data: updatedData,
        pagination, // ✅ optional, available only when paginated API is used
        message,
      };
    } catch (error) {
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);




export const getProductById = createAsyncThunk<
iGenericResponse<iProductDetails | null> | null,
{productId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("getProductById"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await productService.getProductDetails(arg.productId);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
  const item = data.data;
  if (item.product?.is_imported === 1) {
    const shipping = parseFloat(item.product.shippingPrice || '0');
    const packaging = parseFloat(item.product.packagingCharges || '0');
    const cost = parseFloat(item.product.cost_price || '0');
	const taxPercent = Number(item.product.taxesAndCharges || '0'); // Convert to number
const taxCharges = (cost * taxPercent) / 100;
    // console.log("📦 Shipping:", shipping, "📦 Packaging:", packaging, "💰 Cost:", cost);


    item.product.cost_price = shipping + packaging + cost + taxCharges;
    item.product.shippingPrice = "0";

    item.product.packagingCharges = 0;

	item.product.taxesAndCharges="0";
	item.product.taxOptions='';
  }
  return {
    data: item,
    message,
  };
}
 else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateProduct = createAsyncThunk<
			iGenericResponse<any | null> | null,
			{
				title: string;
				sku: string;
				product_type: string;
				category_id: string;
				subCategory:string;
				description: string;
				product_image: string;
				price: number;
				cost_price: number;
				sale_price: number;
				retail_price: number;
				inventory_status: string;
				availability: string;
				global_trade_item_number: string;
				manufacturer_part_number: string;
				brand_name: string;
				images: Array<File | string>;
				videos: Array<File | string>;
				customFields?:Array<{label:string,value:string}>;
				shippingPrice: number;
				internationalshippingPrice:number;
				tags?: Array<string>;
				product_upc_ean: string;
				custom_field_name: string;
				custom_field_value: string;
				is_shipping_free: boolean;
				page_title: string;
				meta_keywords: string;
				meta_description: string;
				product_url: string;
				delivery_event_name: string;
				variants: Array<{ variant_name: string; variant_value: string }>;
				shipping_details: Array<{ location_name: string; shipping_charge: number }>;
				slug: string;
				delivery_from_date:Date;
				delivery_to_date:Date;
				sizes: string[];
				color_images: string[];
				about: string;
				lowStock:string;
				currentStock:string;
				taxesAndCharges: string;
				isPackagingCharges:boolean;
				packagingCharges:number;

			},
			{
				rejectValue: iStateMessage;
			}
>(
	
	curriedGetThunkName('productUpdate'),

	// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
		async (arg, { rejectWithValue }) => {
		try {
			// Call the product service to add a product
			const response = await productService.updateProduct(arg);

			if (response) {
				const { httpStatusCode, data, message } = response;

				switch (httpStatusCode) {
					case httpStatusCodes.SUCCESS_OK: {
						if (data && data.data) {
							// Map iProductDetails to iProductResponse
							return {
								data: {
									orders: data.data,
									message,
								}
							};
						} else {
							return rejectWithValue({
								httpStatusCode,
								message: 'Product data is missing',
							});
						}
					}
					default: {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
			} else {
				return rejectWithValue({
					message: 'No response received from the server',
				});
			}
		} catch (error) {
			console.error('Error in productAdd thunk:', error);
			return rejectWithValue({
				message: 'Something went wrong while adding the product',
			});
		}
	}
);

// export const deleteProduct = createAsyncThunk<
// iGenericResponse<any | null> | null,
// {productId:string},
// {
// 	rejectValue: iStateMessage;
// }
// >(
// curriedGetThunkName("deleteProduct"),
// // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
// async (arg, {rejectWithValue}) => {
// 	try {
// 		const response = await productService.deleteProduct(arg);
// 		if (response) {
// 			const {httpStatusCode, data, message} = response;
// 			console.log(response, "response hai" ,arg)
// 			switch (httpStatusCode) {
// 				case httpStatusCodes.SUCCESS_OK: {
// 					if (data && data) {
// 						return {
// 							data: {
// 								data: data.data,
// 								message,
// 							}
// 						};
// 					} else {
// 						return rejectWithValue({
// 							httpStatusCode,
// 							message,
// 						});
// 					}
// 				}
// 				default: {
// 					return rejectWithValue({
// 						httpStatusCode,
// 						message,
// 					});
// 				}
// 			}
// 		} else {
// 			return rejectWithValue({
// 				message: "No response received",
// 			});
// 		}
// 	} catch (error) {
// 		console.log("🚀 ~ error:", error);
// 		return rejectWithValue({
// 			message: "Something went wrong",
// 		});
// 	}
// },
// );
export const deleteProduct = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { productId: string | string[] }, // accept single or multiple IDs
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("deleteProduct"),
  // @ts-expect-error
  async (arg, { rejectWithValue }) => {
    try {
      // Normalize IDs into an array
      const payload = Array.isArray(arg.productId)
        ? { productId: arg.productId }
        : { productId: [arg.productId] };

      // Call service with payload in request body
      const response = await productService.deleteProduct(payload);

      if (response) {
        const { httpStatusCode, data, message } = response;

        if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data) {
          return {
            data: {
              data: data.data,
              message,
            },
          };
        } else {
          return rejectWithValue({
            httpStatusCode,
            message,
          });
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);



export const importBulkProduct = createAsyncThunk<
			iGenericResponse<any | null> | null,
			{
				file:File
			},
			{
				rejectValue: iStateMessage;
			}
>(
	
	curriedGetThunkName('importBulkProduct'),
	// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
		async ({file}, { rejectWithValue }) => {
		try {
			// Call the product service to add a product
			const response = await productService.importBulkProduct(file);

			if (response) {
				const { httpStatusCode, data, message } = response;

				switch (httpStatusCode) {
					case httpStatusCodes.SUCCESS_OK: {
						if (data && data.data) {
							// Map iProductDetails to iProductResponse
							return {
								data: {
									orders: data.data,
									message,
								}
							};
						} else {
							return rejectWithValue({
								httpStatusCode,
								message: 'Product data is missing',
							});
						}
					}
					default: {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
			} else {
				return rejectWithValue({
					message: 'No response received from the server',
				});
			}
		} catch (error) {
			console.error('Error in productAdd thunk:', error);
			return rejectWithValue({
				message: 'Something went wrong while adding the product',
			});
		}
	}
);

export const updateFeaturedStatus= createAsyncThunk<
			iGenericResponse<any | null> | null,
			{productId:string,status:boolean,isFeaturedProduct:boolean},
			{
				rejectValue: iStateMessage;
			}
>(
	
	curriedGetThunkName('productUpdateStatus'),

	// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
		async ({productId,status,isFeaturedProduct,}, { rejectWithValue }) => {
		try {
			// Call the product service to add a product
			const response = await productService.productUpdateStatus(productId,status,isFeaturedProduct);

			if (response) {
				const { httpStatusCode, data, message } = response;
				switch (httpStatusCode) {
					case httpStatusCodes.SUCCESS_OK: {
						if (data && data.data) {
							return {
								data: {
									orders: data.data,
									message,
								}
							};
						} else {
							return rejectWithValue({
								httpStatusCode,
								message: 'Product data is missing',
							});
						}
					}
					default: {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
			} else {
				return rejectWithValue({
					message: 'No response received from the server',
				});
			}
		} catch (error) {
			console.error('Error in productAdd thunk:', error);
			return rejectWithValue({
				message: 'Something went wrong while adding the product',
			});
		}
	}
);


export const getBestSellingProduct = createAsyncThunk<
 // @ts-expect-error
  ThunkResponse,
  {vendorId:string},
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getBestSellingProduct"),
  async ({vendorId}, { rejectWithValue }) => {
    try {
      const response = await productService.getBestSellingProduct(vendorId);
      
      if (response?.httpStatusCode === httpStatusCodes.SUCCESS_OK && response.data) {
        return {
          httpStatusCode: response.httpStatusCode,
		  // @ts-expect-error
          data: response.data.data as Product[], // Access nested data and cast to Product[]
          message: response.message
        };
      }
      
      return rejectWithValue({
        message: response?.message || "Failed to fetch products"
      });
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong"
      });
    }
  }
);